import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSi = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 61 80",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(2 20)",
		fill: "none",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5 26V15.414a1 1 0 01.293-.707L8 12h0V6.121A5.121 5.121 0 0113.121 1H22l4 11h10.879A5.121 5.121 0 0142 17.121V21h2a1 1 0 011 1v2.586a1 1 0 01-.293.707L41 29h0",
				stroke: "#000",
				strokeWidth: 2
			}),
			/* @__PURE__ */ _jsx("rect", {
				stroke: "#000",
				strokeWidth: 2,
				x: -1,
				y: 26,
				width: 44,
				height: 14,
				rx: 6.5
			}),
			/* @__PURE__ */ _jsx("g", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", { d: "M9.148 19h3.704c.634 0 1.148-.448 1.148-1s-.514-1-1.148-1H9.148C8.514 17 8 17.448 8 18s.514 1 1.148 1zM8 22c0 .552.47 1 1.052 1h7.896C17.53 23 18 22.552 18 22s-.47-1-1.052-1H9.052C8.47 21 8 21.448 8 22z" })
			}),
			/* @__PURE__ */ _jsx("rect", {
				fill: "#0D0E10",
				x: 20,
				width: 6,
				height: 2,
				rx: 1
			}),
			/* @__PURE__ */ _jsx("g", {
				fill: "#1D1D1B",
				fillRule: "nonzero",
				children: /* @__PURE__ */ _jsx("path", { d: "M30 20c.265 0 .52-.12.707-.334.188-.213.293-.503.293-.805V16.14c0-.63-.448-1.139-1-1.139s-1 .51-1 1.139v2.722c0 .63.448 1.139 1 1.139zM34.005 20a.943.943 0 00.703-.327c.187-.21.29-.493.287-.788v-2.664c.037-.422-.145-.83-.468-1.053a.914.914 0 00-1.054 0c-.323.223-.505.631-.468 1.053v2.664c0 .616.447 1.115 1 1.115zM38 20c.552 0 1-.51 1-1.139V16.14c0-.63-.448-1.139-1-1.139s-1 .51-1 1.139v2.722c0 .63.448 1.139 1 1.139z" })
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#000",
				d: "M8 11h18v2H8z"
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M13 2h2v9h-2z"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 6,
				cy: 33,
				r: 3
			}),
			/* @__PURE__ */ _jsx("circle", {
				fill: "#0D0E10",
				cx: 36,
				cy: 33,
				r: 3
			}),
			/* @__PURE__ */ _jsx("path", {
				fill: "#0D0E10",
				d: "M7 32h28v2H7z"
			}),
			/* @__PURE__ */ _jsxs("g", {
				transform: "translate(42 27)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						fill: "#0D0E10",
						x: 11,
						y: 12,
						width: 6,
						height: 2,
						rx: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#0D0E10",
						y: 8,
						width: 6,
						height: 2,
						rx: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						fill: "#0D0E10",
						y: 3,
						width: 6,
						height: 2,
						rx: 1
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M8.28-1A1.997 1.997 0 0110.176.368h0L14.387 13H7a1.994 1.994 0 01-1.414-.586A1.994 1.994 0 015 11h0V1c0-.552.224-1.052.586-1.414A1.994 1.994 0 017-1h0z",
						stroke: "#0D0E10",
						strokeWidth: 2
					})
				]
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34 11V5.5a.5.5 0 00-.5-.5H32h0",
				stroke: "#0D0E10",
				strokeWidth: 2,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgSi;
